module.exports = __webpack_public_path__ + "img/person-pinball.0a0a3dc2.svg";